export default "__VITE_ASSET__DGeUf8XA__"